/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { RDMClientService } from 'src/app/shared-resources/services/rdm-client.service';
import { RefValue } from 'base-shared';

@Injectable({
  providedIn: 'root'
})
export class RiskManagementTableService {
  rdmList: RefValue[];

  constructor(
    private http: HttpClient,
    public store: Store,
    private rdmService: RDMClientService
  ) {}

  getRiskMgmtTblData(
    referenceCode?: string,
    importer?: string,
    agentCode?: string,
    submitter?: string,
    validFrom?: string,
    inspectionAction?: string,
    validTo?: string,
    page?: number,
    size?: number,
    sort?: string,
    referanceType?: string
  ): Observable<any> {
    let params = new HttpParams();
    if (referenceCode) params = params.set('referenceCode', referenceCode);
    if (importer) params = params.set('importer', importer);
    if (agentCode) params = params.set('agentCode', agentCode);
    if (submitter) params = params.set('submitter', submitter);
    if (validFrom) params = params.set('validFrom', validFrom);
    if (inspectionAction) params = params.set('inspectionAction', inspectionAction);
    if (validTo) params = params.set('validTo', validTo);
    if (page !== undefined) params = params.set('page', page.toString());
    if (size !== undefined) params = params.set('size', size.toString());
    if (sort) params = params.set('sort', sort);
    if (referanceType) params = params.set('referanceType', referanceType);

    return this.http.get(`${environment.baseUrl}${environment.wso2amEndPoint}/intelligenceman${environment.wso2amApiVersion}/api/v1/riskAss/search`, { params });
  }

  downloadBinary(id: string): Observable<Blob> {
    return this.http.get(`${environment.baseUrl}${environment.wso2amEndPoint}/${id}`, { responseType: 'blob' });
  }

  downloadAttachment(url: string, cntType?: string): Observable<Blob> {
    console.log(cntType);
    return this.http.get(`${environment.baseUrl}${environment.wso2amEndPoint}${url}`, { responseType: 'blob' });
  }

  tarriffRdmData(): Observable<any> {
    return this.http.get(`${environment.baseUrl}${environment.wso2amEndPoint}/tariff${environment.wso2amApiVersion}/api/v1/getTariffCode`);
  }

  productRdmData(): Observable<any> {
    return this.http.get(`${environment.baseUrl}${environment.wso2amEndPoint}/tariff${environment.wso2amApiVersion}/api/v1/tariff/product/search`);
  }

  getRdmParentRefType(parentRefValue: any, page?: number, size?: number, sort?: string, label?: string): Observable<any> {
    let params = new HttpParams();
    if (parentRefValue) params = params.set('parentRefValue', parentRefValue);
    if (page !== undefined) params = params.set('page', page.toString());
    if (size !== undefined) params = params.set('size', size.toString());
    if (sort) params = params.set('sort', sort);
    if (label) params = params.set('label', label);

    return this.http.get(`${environment.baseUrl}${environment.wso2amEndPoint}/rdm${environment.wso2amApiVersion}/api/v1/values`, { params });
  }

  getDeclaration(referanceId: number | string): Observable<any> {
    return this.http.get(`${environment.baseUrl}${environment.wso2amEndPoint}/intelligencemgmt${environment.wso2amApiVersion}/api/v1/declaration/getDeclaration/${referanceId}`);
  }

    rdmValues(refTypeLabel: string): Observable<any> {
    const url = `${environment.baseUrl}/rdm/api/v1/values/search/filter?refTypeLabel=${refTypeLabel}`;
    return this.http.get<any>(url);
  }

  getDeclarationsByRiskId(riskInformationId: string | number, page = 0, size = 10, sort?: string): Observable<any> {
    let params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    if (sort) params = params.set('sort', sort);
    return this.http.get(`${environment.baseUrl}${environment.wso2amEndPoint}/intelligenceman${environment.wso2amApiVersion}/api/v1/risk/information/declaration/${riskInformationId}`, { params });
  }
}
